import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo_home.png'


const _hoisted_1 = { class: "opModal stepModal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "title-3 mt-4" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "mt-5" }

export function render(_ctx: any,_cache: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          class: "text-uppercase fw-bold",
          localizedKey: "Scegli l'azione",
          text: "Scegli l'azione"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          type: "button",
          class: "btn btn-hollow",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pulisciTavola && _ctx.pulisciTavola(...args)))
        }, [
          _createVNode(_component_localized_text, {
            class: "text-uppercase",
            localizedKey: "Pulisci tavola",
            text: "Pulisci tavola"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          type: "button",
          class: "btn btn-hollow",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salvaPerDopo && _ctx.salvaPerDopo(...args)))
        }, [
          _createVNode(_component_localized_text, {
            class: "text-uppercase",
            localizedKey: "Salva per dopo",
            text: "Salva per dopo"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          type: "button",
          class: "btn btn-hollow",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.esportaPdf && _ctx.esportaPdf(...args)))
        }, [
          _createVNode(_component_localized_text, {
            class: "text-uppercase",
            localizedKey: "Esporta pdf",
            text: "Esporta pdf"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          type: "button",
          class: "btn btn-hollow",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_localized_text, {
            class: "text-uppercase",
            localizedKey: "Chiudi",
            text: "Chiudi"
          })
        ])
      ])
    ])
  ]))
}